import { render, staticRenderFns } from "./mainPage-entrance.vue?vue&type=template&id=13ced62c&scoped=true"
import script from "./mainPage-entrance.vue?vue&type=script&lang=js"
export * from "./mainPage-entrance.vue?vue&type=script&lang=js"
import style0 from "./mainPage-entrance.vue?vue&type=style&index=0&id=13ced62c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ced62c",
  null
  
)

export default component.exports